<template>
<div class="main my">
  <!-- 场馆配置页 -->
  <van-cell-group class="ptm pbm">
    <van-cell class="fs3" :title="clubInfo.title" value="预览" value-class="fs2" :label="clubInfo.user?clubInfo.user.nickname +' | 管理员' :'管理员'" :center="true"  is-link :to="{name: 'venue',params: {clubId: clubInfo.id}}"/>
  </van-cell-group>

  <van-cell-group class="mtm">
    <van-cell title="基本信息" :center="true"  is-link :to="'/setclubinfo'"/>
    <van-cell title="门店管理" :center="true"  is-link :to="'/setclubstore'"/>
  </van-cell-group>

  <van-cell-group class="mtm">
    <van-cell title="产品管理" :center="true"  is-link :to="'/setproductlist'"/>
  </van-cell-group>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import router from '@/router';
import {
  Button,
  Row,
  Col,Toast
} from 'vant';

Vue.use(Button).use(Row).use(Col).use(Toast);

export default {
  components: {
  },
  data() {
    return {
      clubInfo: {}, // 当前俱乐部信息
      auths:[], //当前权限
    }
  },
  created(){
    // 获取俱乐部信息
    this.$http.post('club_manage/getInfo').then(res => {
      if (!res.data.code) {
        this.clubInfo = res.data.value
      } else {
        Toast.fail(res.data.message);
      }
    })
  },
  methods: {
    goTo(id){
      this.$router.push({ name: 'venueinfo',params: {clubid: id}})
    }
  }
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/manage/SetClub.vue